export default __webpack_public_path__ + "static/moment-0cece7f58378b285c27281d971f8b8a1.png";